import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { UpdateSensorsBatchResponsePayload } from '../models/sensorPayloadModels';
import { updateSensorsBatchResponseToModel } from '../mappers/payloadToUpdateSensorsBatch';
import { updateSensorsBatchListModelToPayload } from '../mappers/updateSensorsBatchToPayload';
import { UpdateSensorsBatchItemModel, UpdateSensorsBatchResponseItemModel } from '../models/sensorEntityModels';

const getUrl = (host: string) => {
  return `${host}/sensors/batch`;
};

export const UpdateSensorsBatch = async ({
  token,
  host,
  sensorsData,
}: {
  token: string;
  host: string;
  sensorsData: UpdateSensorsBatchItemModel[];
}): Promise<UpdateSensorsBatchResponseItemModel[]> => {
  try {
    const url = getUrl(host);
    const mappedData = updateSensorsBatchListModelToPayload(sensorsData);

    const options: AxiosRequestConfig = {
      url,
      method: 'PATCH',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };

    const { data } = (await axios(options)) as AxiosResponse<UpdateSensorsBatchResponsePayload | undefined>;

    return updateSensorsBatchResponseToModel(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
